import { useMetaStore } from '../store/MetaStore'

const ErrorDisplay = ({customStyle}) => {
  const errorMsg = useMetaStore((state) => state.errorMsg)

  if (errorMsg?.length > 0) {
    return <div style={{ fontSize: '18px', color: 'red', fontWeight: 'bold', ...customStyle }}>{errorMsg}</div>
  } else {
    return <></>
  }
}

export default ErrorDisplay
